<template>
 
  <div class="editBox someBox">
    <t-input 
      type="number" 
      borderless
       label="折扣：" 
      class="numberInput" 
      v-model="discountValue" 
      @change="changeDiscount" 
    />
    
    <t-icon name="swap" size="48rpx" />
    
    <t-input 
      type="number" 
       label="金额：" 
       borderless
      class="numberInput2" 
      v-model="sumPrice2Value" 
      @change="changePrice" 
    />
  </div>
<div class="confirmBtnBox">
  <t-button class="someConfirmBtn" theme="primary" @click="doConfirmData">确定</t-button>


</div>

</template>

<script>
import { ref, watch } from 'vue';
import Decimal from 'decimal';
 
export default {
  name: 'MyEditPrice',
 
  props: {
    index: {
      type: Number,
      default: 0
    },
    discount: {
      type: Number,
      default: 0
    },
    sumPrice: {
      type: Number,
      default: 0
    },
    sumPrice2: {
      type: Number,
      default: 0
    }
  },
  emits: ['onChange'],
  setup(props, { emit }) {
    // 使用 ref 来创建响应式数据
    const discountValue = ref(props.discount);
    const sumPrice2Value = ref(props.sumPrice2);

    // 监听 props 变化并更新本地值
    watch(() => props.discount, (newVal) => {
      discountValue.value = newVal;
    });

    watch(() => props.sumPrice2, (newVal) => {
      sumPrice2Value.value = newVal;
    });

    const changePrice = (e) => {
      const value = parseFloat(e) || 0;
      
      if (props.sumPrice === 0) return;
      
      const discount = props.sumPrice ?new Decimal(value).div(props.sumPrice).mul(10).toNumber():0;
      
      discountValue.value = discount;
      sumPrice2Value.value = value;
    };

    const changeDiscount = (e) => {
      const value = parseFloat(e) || 0;
      
      const sumPrice2 =new Decimal(props.sumPrice).mul(value).div(10).toNumber();
      
      discountValue.value = value;
      sumPrice2Value.value = sumPrice2;
    };

    const doConfirmData = () => {
      emit('onChange', {
        index: props.index,
        sumPrice: props.sumPrice,
        sumPrice2: parseFloat(sumPrice2Value.value),
        discount: parseFloat(discountValue.value).toFixed(2)
      });
    };

    return {
      discountValue,
      sumPrice2Value,
      changePrice,
      changeDiscount,
      doConfirmData
    };
  }
};
</script>

<style scoped>
.editBox{
 
 padding-bottom: 3vw;
  display:flex;
  justify-content:space-between;
  align-items: center;
}
.numberInput{
  height: 2.5rem;
  font-size: 1.6rem;
}
.numberInput2{
 text-align: right;
  font-size: 1.6rem;
 
 
}
 
.someBox{
  padding-bottom: 40vw;
}
.someConfirmBtn{

  margin:0;
}
.headTitle{
    padding:2vw;
}
.confirmBtnBox{
    display: flex;
    justify-content: end;
}
</style>